import dayjs from "dayjs";

export const dateTimeFormatter = (value: string | undefined): string => {
  if (!value) return "—";
  const d = dayjs(value);

  return d.isValid() ? d.format("YYYY-MM-DD hh:mm:ss A") : value;
};

export const booleanValueGetter = (
  value: boolean | undefined | null,
): boolean => value ?? false;
